export default __webpack_public_path__ + "892e9e34b7e71d76d64109654621686f.png";